import client from "./client";

const chatAPI = {
  // Get all chats (optionally filtered by load_id)
  getChats(loadId = null) {
    const params = loadId ? { load_id: loadId } : {};
    return client.get("/chats", { params });
  },

  // Get messages for a specific chat
  getMessages(loadId, userId, limit = 50, offset = 0) {
    return client.get("/chats/messages", {
      params: { load_id: loadId, user_id: userId, limit, offset },
    });
  },

  // Send a new message
  sendMessage(loadId, userId, message, fileUrl = null, fileName = null) {
    return client.post("/chats/message", {
      load_id: loadId,
      user_id: userId,
      message: message,
      file_url: fileUrl,
      file_name: fileName,
    });
  },

  // Mark messages as read
  markAsRead(loadId, userId) {
    return client.put("/chats/mark-read", {
      load_id: loadId,
      user_id: userId,
    });
  },

  // Get total unread count
  getUnreadCount() {
    return client.get("/chats/unread-count");
  },

  // Get unread count for a specific chat
  getChatUnreadCount(loadId, userId) {
    return client.get("/chats/chat-unread-count", {
      params: { load_id: loadId, user_id: userId },
    });
  },
};

export default chatAPI;
